import Menu from './Compartido/Menu.jsx';
import TextosPoliticaPrivacidad from './PoliticaPrivacidad/TextosPoliticaPrivacidad.jsx';
import Footer from './Compartido/Footer.jsx';
import Scripts from './Compartido/Scripts.jsx';

const PoliticaPrivacidad = (props) => {
    return (
        <main>
            <Menu
                lang={props.lang}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                config={props.websgrupo}
                pagina="5_Política-de-Privacidad"
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />
            <TextosPoliticaPrivacidad
                lang={props.lang}
                unapolitica={props.textopoliticaprivacidad}
            />
            <Footer
                lang={props.lang}
                datos={props.websgrupo}
            />
            <Scripts />
        </main>
    )
}
export default PoliticaPrivacidad;

